
// Any fields that should be validated must have an entry in this object.
const validators = {
  email: {
    regExp: /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,24}$/,
    error: 'invalidEmail',
  },
  phone: {
    regExp: /^[EXText.+#\-()\d\s]{7,25}$/,
    error: 'invalidPhone',
  },
}

// The string returned must be a key of 'errorMessages' in data/strings.json.
// (Or return nothing if no error.)
export default function getFieldError(name, rawValue, config) {
  const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
  if (value) {
    if (validators[name] && !validators[name].regExp.test(value)) {
      return validators[name].error
    }
  }
  else if (config.required) {
    return 'required'
  }
}
